import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataSellingType } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_SELLING_TYPE =
  defineMasterdataEntity<MasterdataSellingType>({
    name: 'selling-type',
    responseKey: 'sellingTypes',
    displayWith: (t) => keyName(t.key, t.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-cash-register',
    title: 'Verkaufsartsuche',
    label: 'Verkaufsart',
    placeholder: 'Verkaufsart suchen...',
    columns: [
      {
        label: 'Verkaufsart',
        type: 'entity',
        icon: 'fa-regular fa-cash-register',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Schlüssel', value: (e) => e.key },
      { label: 'Bezeichnung', value: (e) => e.name },
      { label: 'Preisänderung %', value: (e) => e.priceChangePercent },
    ],
  });
